/**
 * 销售主管 - 数据中心 - 月度签约（折线图）
 */
<template>
  <div class="monthly-sign-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/salesSupervisor/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item>月度签约</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="formInline.startMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="开始月份"
            class="month-picker"
          />
          <span class="range-sep">至</span>
          <el-date-picker
            v-model="formInline.endMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="结束月份"
            class="month-picker"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-card shadow="hover" class="chart-card">
      <div slot="header" class="chart-card-header">
        <i class="el-icon-s-data header-icon"></i>
        <span>团队月度签约客户数</span>
        <el-button type="text" class="header-link" icon="el-icon-view" @click="openSalesFlowDialog">
          按销售查看
        </el-button>
      </div>
      <div v-loading="loading" class="chart-body">
        <div ref="chartRef" class="chart-single-wrap"></div>
        <div v-if="!loading && !chartHasData" class="chart-empty">
          <i class="el-icon-document"></i>
          <p>暂无数据</p>
        </div>
      </div>
    </el-card>

    <el-dialog
      title="每个销售月度签约"
      :visible.sync="salesFlowDialogVisible"
      width="900px"
      class="sales-flow-dialog"
      @open="onSalesFlowDialogOpen"
      @close="onSalesFlowDialogClose"
    >
      <div v-loading="salesFlowLoading" class="dialog-chart-body">
        <div ref="salesFlowChartRef" class="dialog-chart-wrap"></div>
        <div v-if="!salesFlowLoading && !salesFlowHasData" class="chart-empty">
          <i class="el-icon-document"></i>
          <p>暂无数据</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getSalesTeamMonthlySignCount, getSalesTeamSalesMonthlySignCount } from '@/api/userMG';

const SERIES_COLORS = [
  '#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399',
  '#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae',
];

function getSeriesColors(count) {
  if (count <= SERIES_COLORS.length) return SERIES_COLORS.slice(0, count);
  const colors = [...SERIES_COLORS];
  for (let i = SERIES_COLORS.length; i < count; i++) {
    const h = (i * 37) % 360;
    const s = 0.5 + (i % 3) * 0.15;
    const l = 0.45 + (i % 5) * 0.05;
    colors.push(hslToHex(h, s, l));
  }
  return colors;
}
function hslToHex(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n) => {
    const k = (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  const r = Math.round(f(0) * 255);
  const g = Math.round(f(8) * 255);
  const b = Math.round(f(4) * 255);
  return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('');
}

export default {
  name: 'SalesSupervisorMonthlySignCount',
  data() {
    const now = new Date();
    const startMonth = `${now.getFullYear()}-01`;
    const endMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    return {
      formInline: {
        startMonth,
        endMonth,
      },
      loading: false,
      rawList: [],
      chartInstance: null,
      salesFlowDialogVisible: false,
      salesFlowLoading: false,
      salesFlowRawList: [],
      salesFlowChartInstance: null,
    };
  },
  computed: {
    chartHasData() {
      return this.rawList && this.rawList.length > 0;
    },
    salesFlowHasData() {
      return this.salesFlowRawList && this.salesFlowRawList.length > 0;
    },
  },
  mounted() {
    this.search();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance && this.chartInstance.dispose) {
      this.chartInstance.dispose();
    }
    if (this.salesFlowChartInstance && this.salesFlowChartInstance.dispose) {
      this.salesFlowChartInstance.dispose();
    }
  },
  methods: {
    search() {
      const start = this.formInline.startMonth;
      const end = this.formInline.endMonth;
      if (!start || !end) {
        this.$message.warning('请选择时间范围');
        return;
      }
      const [y1, m1] = start.split('-').map(Number);
      const [y2, m2] = end.split('-').map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning('结束月份不能早于开始月份');
        return;
      }
      this.loading = true;
      getSalesTeamMonthlySignCount({
        startDate: start,
        endDate: end,
      })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0) && res.data) {
            const data = res.data;
            this.rawList = Array.isArray(data) ? data : (data.items || []);
            this.$nextTick(() => this.renderChart());
          } else {
            this.rawList = [];
            this.renderChart();
            const msg = (res && (res.msg || res.message)) || '';
            if (msg) this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.rawList = [];
          this.renderChart();
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || '';
          if (msg) this.$message.error(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSortedList(list) {
      const arr = (list || []).slice();
      arr.sort((a, b) => (a.yearMonth || '').localeCompare(b.yearMonth || ''));
      return arr;
    },
    renderChart() {
      if (this.chartInstance && this.chartInstance.dispose) {
        this.chartInstance.dispose();
      }
      this.chartInstance = null;
      const dom = this.$refs.chartRef;
      if (!dom) return;
      const sorted = this.getSortedList(this.rawList);
      const months = sorted.map((d) => d.yearMonth);
      const monthLabels = months.map((ym) => {
        const s = String(ym);
        return s.length >= 7 && s.indexOf('-') !== -1 ? s.replace('-', '年') + '月' : s;
      });
      const values = sorted.map((d) => (d.signCount != null ? Number(d.signCount) : 0));
      const chart = echarts.init(dom);
      this.chartInstance = chart;
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line' },
          formatter: (params) => {
            if (!params || !params.length) return '';
            const idx = params[0].dataIndex;
            const ym = months[idx] || '';
            const val = sorted[idx] ? sorted[idx].signCount : 0;
            return `${ym}<br/>当月签约客户数：${Number(val).toFixed(0)} 个`;
          },
        },
        grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
        xAxis: {
          type: 'category',
          data: monthLabels.length ? monthLabels : ['暂无数据'],
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisLabel: { color: '#606266', fontSize: 12 },
        },
        yAxis: {
          type: 'value',
          name: '签约客户数(个)',
          nameTextStyle: { color: '#606266', fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } },
          axisLabel: { color: '#606266', fontSize: 12 },
          minInterval: 1,
        },
        series: [
          {
            name: '月度签约客户数',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            data: values.length ? values : [0],
            itemStyle: { color: '#409EFF' },
            lineStyle: { width: 2 },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(64, 158, 255, 0.25)' },
                  { offset: 1, color: 'rgba(64, 158, 255, 0.02)' },
                ],
              },
            },
          },
        ],
      };
      chart.setOption(option, true);
      this.$nextTick(() => chart.resize());
    },
    openSalesFlowDialog() {
      const start = this.formInline.startMonth;
      const end = this.formInline.endMonth;
      if (!start || !end) {
        this.$message.warning('请先选择时间范围');
        return;
      }
      const [y1, m1] = start.split('-').map(Number);
      const [y2, m2] = end.split('-').map(Number);
      if ((y2 - y1) * 12 + (m2 - m1) < 0) {
        this.$message.warning('结束月份不能早于开始月份');
        return;
      }
      this.salesFlowDialogVisible = true;
    },
    onSalesFlowDialogOpen() {
      const start = this.formInline.startMonth;
      const end = this.formInline.endMonth;
      this.salesFlowLoading = true;
      getSalesTeamSalesMonthlySignCount({ startDate: start, endDate: end })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0) && res.data) {
            const data = res.data;
            this.salesFlowRawList = Array.isArray(data) ? data : (data.items || []);
            this.$nextTick(() => this.renderSalesFlowChart());
          } else {
            this.salesFlowRawList = [];
            this.$nextTick(() => this.renderSalesFlowChart());
            const msg = (res && (res.msg || res.message)) || '';
            if (msg) this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.salesFlowRawList = [];
          this.$nextTick(() => this.renderSalesFlowChart());
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || '';
          if (msg) this.$message.error(msg);
        })
        .finally(() => { this.salesFlowLoading = false; });
    },
    onSalesFlowDialogClose() {
      if (this.salesFlowChartInstance && this.salesFlowChartInstance.dispose) {
        this.salesFlowChartInstance.dispose();
      }
      this.salesFlowChartInstance = null;
    },
    buildSalesFlowChartData() {
      const list = this.salesFlowRawList || [];
      const monthSet = new Set();
      const salesMap = new Map();
      list.forEach((row) => {
        const ym = (row.yearMonth || '').toString().trim();
        if (!ym) return;
        monthSet.add(ym);
        const id = row.salesId != null ? row.salesId : row.salesName;
        if (!salesMap.has(id)) {
          salesMap.set(id, { salesName: row.salesName || `销售${id}`, dataByMonth: {} });
        }
        const rec = salesMap.get(id);
        rec.dataByMonth[ym] = { signCount: Number(row.signCount) || 0 };
      });
      const months = Array.from(monthSet).sort((a, b) => a.localeCompare(b));
      const salesList = Array.from(salesMap.entries()).map(([id, rec]) => ({
        salesId: id,
        salesName: rec.salesName,
        dataByMonth: rec.dataByMonth,
      }));
      return { months, salesList };
    },
    renderSalesFlowChart() {
      if (this.salesFlowChartInstance && this.salesFlowChartInstance.dispose) {
        this.salesFlowChartInstance.dispose();
      }
      this.salesFlowChartInstance = null;
      const dom = this.$refs.salesFlowChartRef;
      if (!dom) return;
      const { months, salesList } = this.buildSalesFlowChartData();
      const monthLabels = months.map((ym) => {
        const s = String(ym);
        return s.length >= 7 && s.indexOf('-') !== -1 ? s.replace('-', '年') + '月' : s;
      });
      const chart = echarts.init(dom);
      this.salesFlowChartInstance = chart;
      const palette = getSeriesColors(salesList.length);
      const series = salesList.map((s, i) => ({
        name: s.salesName,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: months.map((ym) => (s.dataByMonth[ym] ? s.dataByMonth[ym].signCount : 0)),
        itemStyle: { color: palette[i] },
        lineStyle: { width: 2 },
      }));
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line' },
          formatter: (params) => {
            if (!params || !params.length) return '';
            const idx = params[0].dataIndex;
            const ym = months[idx] || '';
            let html = `${ym}<br/>`;
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}：${Number(p.value).toFixed(0)} 个<br/>`;
            });
            return html;
          },
        },
        legend: { type: 'scroll', bottom: 0, data: salesList.map((s) => s.salesName) },
        grid: { left: 72, right: 32, bottom: 56, top: 44, containLabel: true },
        xAxis: {
          type: 'category',
          data: monthLabels.length ? monthLabels : ['暂无数据'],
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisLabel: { color: '#606266', fontSize: 12 },
        },
        yAxis: {
          type: 'value',
          name: '签约客户数(个)',
          nameTextStyle: { color: '#606266', fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } },
          axisLabel: { color: '#606266', fontSize: 12 },
          minInterval: 1,
        },
        series,
      };
      chart.setOption(option, true);
      this.$nextTick(() => chart.resize());
    },
    handleResize() {
      if (this.chartInstance && this.chartInstance.resize) {
        this.chartInstance.resize();
      }
      if (this.salesFlowChartInstance && this.salesFlowChartInstance.resize) {
        this.salesFlowChartInstance.resize();
      }
    },
    reset() {
      const now = new Date();
      this.formInline.startMonth = `${now.getFullYear()}-01`;
      this.formInline.endMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      this.rawList = [];
      this.search();
    },
  },
};
</script>

<style scoped>
.monthly-sign-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
}
.search-form .month-picker {
  width: 140px;
}
.range-sep {
  margin: 0 10px;
  color: #909399;
  font-size: 13px;
}
.chart-card {
  border-radius: 8px;
  overflow: hidden;
}
.chart-card >>> .el-card__header {
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
}
.chart-card-header {
  display: flex;
  align-items: center;
}
.chart-card-header .header-icon {
  margin-right: 8px;
  font-size: 18px;
  color: #409eff;
}
.chart-card-header .header-link {
  margin-left: auto;
  padding: 0 8px;
  font-size: 14px;
}
.chart-card >>> .el-card__body {
  padding: 20px;
}
.chart-body {
  min-height: 380px;
  position: relative;
}
.chart-single-wrap {
  width: 100%;
  height: 380px;
}
.chart-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #fafafa;
  border-radius: 6px;
}
.chart-empty i {
  font-size: 48px;
  margin-bottom: 12px;
}
.chart-empty p {
  margin: 0;
  font-size: 14px;
  color: #909399;
}
.sales-flow-dialog >>> .el-dialog__body {
  padding: 20px 20px 16px;
}
.dialog-chart-body {
  min-height: 360px;
  position: relative;
  padding-top: 8px;
}
.dialog-chart-wrap {
  width: 100%;
  height: 360px;
}
</style>




// WEBPACK FOOTER //
// src/views/salesSupervisor/monthlySignCount.vue